/**
 * @description 公共工具类，命名方式为 methodNameUtil
 * @author yinshipeng
 */
import Cookies from 'js-cookie';
let cloneDeep = require('lodash/cloneDeep');

/**
 * 将对象重新封装成{code:'',label:''}型对象
 * 原对象属性为code 原对象属性值为label
 * @param obj
 * @returns {Array}
 */
export const packSelectObjUtil = function(obj) {
    var objArr = [];
    for (var p in obj) {
        var object = {};
        object.code = p;
        object.label = obj[p];
        objArr.push(object);
    }
    return objArr;
};

/**
 * 获取URL中的参数
 * @param {*} name
 */
export const getParamString = function(name) {
    let url = document.location.toString();
    let arrObj = url.split('?');
    if (arrObj.length > 1) {
        let arrPara = arrObj[1].split('&');
        let arr;
        for (let i = 0; i < arrPara.length; i++) {
            arr = arrPara[i].split('=');
            if (arr != null && arr[0] === name) {
                return arr[1];
            }
        }
    }
    return '';
};

/**
 * 获取token
 */
export const getToken = function() {
    var t = getParamString('token');
    if (!t) {
        t = localStorage.getItem('auth-token');
    } else {
        localStorage.setItem('auth-token', t);
    }
    return t;
};

/**
 * 深拷贝
 * @param {要深拷贝的值} value
 */
export const copyDeep = function(value) {
    return cloneDeep(value);
};

/**
 * 获取API头部地址
 * @param {*} baseURL
 */
export const getBaseURL = baseURL => {
    return process.env['VUE_APP_' + baseURL.toUpperCase()];
};

/**
 * 判断文件是否超出最大值
 * @param {*} file
 * @param {*} limitSize
 */
export const getFileLimitSize = (file, limitSize) => {
    const isLtM = file.size / 1024 / 1024 < limitSize;
    return isLtM;
};

/**
 * 删除对象指定属性
 * @param {*} obj // 要删除的对象
 * @param {*} uselessKeys // 对象要删除的属性
 */
export const omit = (obj, uselessKeys) => {
    let filterObj = Object.keys(obj).reduce((arr, key) => {
        return uselessKeys.includes(key)
            ? { ...arr }
            : { ...arr, [key]: obj[key] };
    }, {});
    return filterObj;
};

/*
 * 导出Excel
 * @param {接口返回对象} res
 * @param {文件名称} name
 */
export const exportExcel = function(res, name) {
    const blob = new Blob([res.data], {
        type: 'application/msexcel'
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    let fileName = name + '.xlsx';
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
};

/*
 * 根据url下载文件，文件名可修改
 * @param {下载链接} url
 * @param {文件名称} name
 */
export const downLoadFile = function(url, name) {
    let type = url.substr(url.lastIndexOf('.'), url.length);
    new Promise(resolve => {
        const xhr = new XMLHttpRequest();
        // 避免 200 from disk cache
        url = url + `?r=${Math.random()}`;
        xhr.open('GET', url, true);
        xhr.responseType = 'blob';
        xhr.onload = () => {
            if (xhr.status === 200) {
                resolve(xhr.response);
            }
        };
        xhr.send();
    }).then(blob => {
        if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, name);
        } else {
            const anchor = document.createElement('a');
            const body = document.querySelector('body');
            anchor.href = window.URL.createObjectURL(blob);
            anchor.download = name.indexOf(type) > -1 ? name : name + type;
            anchor.style.display = 'none';
            body.appendChild(anchor);
            anchor.click();
            body.removeChild(anchor);
            window.URL.revokeObjectURL(anchor.href);
        }
    });
};

/*
 * 判断对象是否为空
 * @param {文件名称} obj
 */

export const isEmpty = function(obj) {
    if (typeof obj === 'undefined' || obj == null || obj === '') {
        return true;
    } else {
        return false;
    }
};

/**
 * 获取X-Hades-Env-Identity
 * @returns
 */
export const getEnvIdentity = function() {
    let t = getParamString('env');
    if (!t) {
        t = Cookies.get('X-Hades-Env-Identity');
    } else {
        Cookies.set('X-Hades-Env-Identity', t);
    }
    return t;
};
